export default __webpack_public_path__ + "static/media/icon_trophy.92e0a176.svg";